import React from 'react';
import StandardButton from '../app_components/StandardButton';

const ProfileDisabledContact = () => (
  <div className="profile-actions">
    <StandardButton
      text="User can't be contacted"
      disabled
      size="large"
      fullWidth
      onClick={() => {}}
    />
  </div>
);

export default ProfileDisabledContact;
